import Image from 'next/image';
import { Icon as IconType } from '@/types/icon';
import { processIcon, hasValidIcon, getIconAlt } from '@/utils/icon';

interface IconProps {
  icon: IconType | undefined | null;
  width: number;
  height: number;
  alt?: string;
  className?: string;
  onClick?: () => void;
}
export default function Icon({ 
  icon, 
  width, 
  height, 
  alt, 
  className = '', 
  onClick 
}: IconProps) {
  // Don't render anything if icon is invalid
  if (!hasValidIcon(icon)) {
    return null;
  }

  const iconSrc = processIcon(icon);
  const iconAlt = alt || getIconAlt(icon);
  
  return (
    <Image
      src={iconSrc}
      alt={iconAlt}
      width={width}
      height={height}
      className={className}
      onClick={onClick}
    />
  );
}